export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6131.d783b828.jpg";